import React from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import isEmpty from 'lodash/isEmpty';

import { OptionHeading } from '../../styles';

const { Option } = Select;

const styles = { width: 200 };

const WeightIntensity = ({
  heatmapWeightField,
  aggregatableFields,
  onChangeWeightIntensity,
}) => (
  <>
    <OptionHeading>Weight By</OptionHeading>
    <p>
      Optional. Choose a numeric field to make some locations contribute more strongly to
      the heatmap.
    </p>
    <Select
      style={styles}
      placeholder="None"
      value={heatmapWeightField || ''}
      onChange={onChangeWeightIntensity}
    >
      <Option key="empty" value="">None</Option>
      {!isEmpty(aggregatableFields) && aggregatableFields.map(({ name }) => (
        <Option key={name} value={name}>{name}</Option>
      ))}
    </Select>
  </>
);

WeightIntensity.propTypes = {
  heatmapWeightField: PropTypes.string,
  aggregatableFields: PropTypes.array.isRequired,
  onChangeWeightIntensity: PropTypes.func.isRequired,
};

export default WeightIntensity;
